import { useContext, useMemo } from "react";
import { POLICY_CATEGORY_LIST } from "@sscs/types";
import { compareValues } from "@sscs/utils";
import { ReportContext } from "../context";
const useCategoryFilterOptions = () => {
    const { supportsYaraPolicies } = useContext(ReportContext);
    return useMemo(() => POLICY_CATEGORY_LIST.filter((category) => {
        return !supportsYaraPolicies ? category !== "yara" : true;
    }).sort((first, second) => compareValues(first[1], second[1], false)), [supportsYaraPolicies]);
};
export default useCategoryFilterOptions;
//# sourceMappingURL=useCategoryFilterOptions.js.map